import styled from 'styled-components'

const borderColor = (props) => props.theme.global.colors['light-7']
const lightColor = (props) => props.theme.global.colors['white']
const darkColor = (props) => props.theme.global.colors['dark-2']
const bgColor = (props) => props.theme.global.colors['background-back']
const buttonHoverColor = (props) => props.theme.global.colors['darkButtonHover']
const lineColor = "#939398"

export const Container = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  border: 1px solid ${borderColor};
  border-radius: 4px;
  background-color: ${lightColor};

  @media screen and (max-width: 992px) {
    padding: 16px;
  }
`

export const OrderInfo = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 4px;
  margin-bottom: 16px;

  @media screen and (max-width: 485px) {
    flex-direction: column;
    align-items: flex-start;
  }
`

export const VerticalLine = styled.p`
  font-size: 16px;
  font-weight: 600;
  color: ${lineColor};
  margin: 0;
  line-height: 165%;

  @media screen and (max-width: 485px) {
    display: none;
  }
`

export const InfoText = styled.p`
  font-size: 16px;
  font-weight: 400;
  color: ${darkColor};
  margin: 0;
  line-height: 165%;

  span {
    font-size: 16px;
    font-weight: 600;
    color: ${darkColor};
    margin: 0;

    @media screen and (max-width: 768px) {
      font-size: 14px;
    }
  }

  @media screen and (max-width: 768px) {
    font-size: 14px;
  }
`

export const MessageBox = styled.div`
  padding: 16px;
  border-radius: 4px;
  background-color: ${bgColor};
  margin-bottom: 24px;

  @media screen and (max-width: 485px) {
    padding: 8px 12px;
  }
`

export const Title = styled.h1`
  font-size: 16px;
  font-weight: 600;
  line-height: 165%;
  color: ${darkColor};
  margin: 0;
`

export const Description = styled.h5`
  font-size: 16px;
  font-weight: 400;
  line-height: 165%;
  color: ${darkColor};
  margin: 0;

  @media screen and (max-width: 992px) {
    font-size: 14px;
  }
`

export const DoneCTA = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 292px;
  height: 48px;
  border-radius: 4px;
  padding: 0 24px;
  border: none;
  outline: none;
  margin: 0 auto;
  background-color: ${darkColor};
  color: ${lightColor};
  font-family: 'Roboto';
  font-size: 16px;
  font-weight: 600;
  line-height: 165%;
  cursor: pointer;

  :hover {
    background-color: ${buttonHoverColor};
  }

  @media screen and (max-width: 992px) {
    width: 100%;
    height: 40px;
    font-size: 14px;
  }
`